import { Component, ElementRef, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-group',
  templateUrl: './group.component.html',
  host: {
    class: 'uex-card-group card-group'
  }
})
export class CardGroupComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
